import React from 'react';
import { Breadcrumb as AntBreadcrumb } from 'antd';

/**
 * Wrapper component for Ant Design Breadcrumb
 * 
 * This wrapper allows us to easily replace Ant Design in the future without changing all imports.
 * It preserves all Ant Design Breadcrumb functionality and sub-components.
 * 
 * @component
 * @example
 * import { Breadcrumb } from '../GeneralComponents/ui';
 * 
 * <Breadcrumb>
 *   <Breadcrumb.Item>Home</Breadcrumb.Item>
 *   <Breadcrumb.Item>Application</Breadcrumb.Item>
 * </Breadcrumb>
 * 
 * @see https://ant.design/components/breadcrumb/ - Ant Design Breadcrumb documentation
 */
const Breadcrumb = (props) => {
  return <AntBreadcrumb {...props} />;
};

// Preserve Breadcrumb sub-components
Breadcrumb.Item = AntBreadcrumb.Item;
Breadcrumb.Separator = AntBreadcrumb.Separator;

export default Breadcrumb;

